/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import { useQuery } from "@tanstack/react-query";
import { getMaterialsTransferHistory } from "./materialsTransferHistoryFunctions";

export function useMaterialsTransferHistory(startDate: string, endDate: string) {
    return useQuery({
        queryKey: ["MATERIALS", "TRANSFER_HISTORY", startDate, endDate],
        queryFn: () => getMaterialsTransferHistory(startDate, endDate),
        select: ({ data }) => data,
    });
}
